import React from 'react'
import { Component } from 'react'
import { render } from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import Wheel from './Wheel'
import PlayButton from './PlayButton'

/** Views */
import {Start} from './views/Start';
import {Spinning} from './views/Spinning';
import {Result} from './views/Result';
import {QuickForm} from './views/QuickForm';
import Form from './views/Form';
import {ThankYou} from './views/ThankYou';

/** Components */
import {Topbar} from './Topbar';
import {Footer} from './Footer';
import {Rules} from './Rules';
import {Terms} from './Terms';

import AssetsLoader from 'assets-loader';
import FontFaceObserver from 'fontfaceobserver';

// Assets
import clickMp3 from '../../audio/244774__door15studio__spin-tick.mp3';
import blankImg from '../../images/blank.png';
import posaLogo from '../../images/posa-logo.png';
import avainlippu from '../../images/avainlippu.png';
import lampImg from '../../images/lamp.png';
import retryImg from '../../images/retry.png';
import thumbImg from '../../images/thumb.png';
import closeIcon from '../../images/close-icon.png';
import result0 from '../../images/wheel-thumb.png';
import result1 from '../../images/wheel-respin.png';
import result2 from '../../images/wheel-lamp.png';

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min; //The maximum is inclusive and the minimum is inclusive 
}

class App extends Component {
  constructor(props) {
    super(props);

    this.history = createBrowserHistory();

    const r = getRandomIntInclusive(0, 1) + 1;

    // Result: 0 = lose, 1 = respin, 2 = win
    this.state = {loaded: false, playing: false, idling: true, rulesOpen: false, termsOpen: false, backBtnVisible: false, result: r};
    this.playButtonClicked = this.playButtonClicked.bind(this);
    this.openRules = this.openRules.bind(this);
    this.closeRules = this.closeRules.bind(this);
    this.openTerms = this.openTerms.bind(this);
    this.closeTerms = this.closeTerms.bind(this);
    this.reload = this.reload.bind(this);
  }

  componentDidMount() {
    this.assetsLoader = new AssetsLoader();

    this.assetsLoader.add(blankImg);
    this.assetsLoader.add(posaLogo);
    this.assetsLoader.add(avainlippu);
    this.assetsLoader.add(lampImg);
    this.assetsLoader.add(retryImg);
    this.assetsLoader.add(thumbImg);
    this.assetsLoader.add(closeIcon);
    this.assetsLoader.add(result0);
    this.assetsLoader.add(result1);
    this.assetsLoader.add(result2);

    this.assetsLoader.add({id: 'click', url: clickMp3});
    this.assetsLoader.start();

    let font = new FontFaceObserver("Chevin Light");
    let fontLoaderPromise = font.load(null, 5000);

    let assetLoaderPromise = new Promise((resolve, reject) => {
      this.assetsLoader.on('complete', (assets) => {
        this.assets = assets;
        resolve();
      });
  
      this.assetsLoader.on('error', () => {
        reject();
      });
    });

    Promise.all([assetLoaderPromise, fontLoaderPromise]).then(() => {
      this.setState({loaded: true});
    }, (e) => {
      console.log("Assets not loaded :(");
    });
  }

  playButtonClicked() {
    this.setState({playing: true, backBtnVisible: true});
  }

  openRules(){
      this.setState({
        rulesOpen: true
     });
  }
  closeRules(e){
    e.preventDefault();
    this.setState({
        rulesOpen: false
     });
  }
  openTerms(){
      this.setState({
        termsOpen: true
     });
  }
  closeTerms(e){
    e.preventDefault();
    this.setState({
        termsOpen: false
     });
  }
  reload(){
    const r = getRandomIntInclusive(0, 1) + 1;
    this.setState({playing: false, idling: true, result: r, backBtnVisible: false});
    this.history.push('/');
  }

  onSpinComplete() {
    this.setState({playing: false, idling: false});
    this.history.push('/result');
  }

  onRespin() {
    this.setState({playing: true, idling: false, result: 2});
    this.history.push('/spinning');
  }

  render(){
    let game;
    if (this.state.loaded) {
      return(
    <Router history={this.history}>
      <div>
      <Topbar>
        <NavLink className="topbar-close" to="/" style={{display:(this.state.backBtnVisible ? 'inline-block' : 'none')}} onClick={this.reload}><img src="./assets/close-icon.835a4b8652ca5c3da3cf8b1189d0e26b.png" /></NavLink>
      </Topbar>
      <div className="main container-fluid">
          <div className="container">
            <div className="row content-row">
              <div className="col-sm-7">
                <div className="wheel-container">
                  <Wheel loaded={this.state.loaded} playing={this.state.playing} idling={this.state.idling} assets={this.assetsLoader} result={this.state.result} onDone={() => { this.onSpinComplete(); }} />
                </div>
              </div>
              
                
                  <Switch>
                    <Route path="/" exact component={() => <Start to="/spinning" text="Pyöräytä" onClick={this.playButtonClicked} visible={this.state.loaded && !this.state.playing}/>} />
                    
                    <Route path="/spinning" exact  component={() => <Spinning playing={this.state.playing} /> } />
                    <Route path="/result" exact  component={() => <Result result={this.state.result} playing={this.state.playing} onRespin={() => { this.onRespin(); }} />} />
                    <Route path="/quickform" exact  component={QuickForm} />
                    <Route path="/form" exact  component={() => <Form onRulesClick={this.openRules} onTermsClick={this.openTerms} />} />
                    <Route path="/thankyou" exact  component={() => <ThankYou reload={this.reload} />} />
                  </Switch>
                
                    
              
            </div>
          </div>
        </div>
        
        
        <Footer onClick={this.openRules}/>
        
        <div className="rules" style={{display:(this.state.rulesOpen ? 'block' : 'none')}}>
          <div className="rules-bg" onClick={this.closeRules}></div>
          <div className="rules-container">
            <div className="rules-inner">
              <a href="#" onClick={this.closeRules} className="close-rules"><img src="./assets/close-icon.835a4b8652ca5c3da3cf8b1189d0e26b.png" /></a>
              <Rules />
            </div>
          </div>
        </div>

        <div className="rules" style={{display:(this.state.termsOpen ? 'block' : 'none')}}>
          <div className="rules-bg" onClick={this.closeTerms}></div>
          <div className="rules-container">
            <div className="rules-inner">
            <a href="#" onClick={this.closeTerms} className="close-rules"><img src="./assets/close-icon.835a4b8652ca5c3da3cf8b1189d0e26b.png" /></a>
              <Terms />
            </div>
          </div>
        </div>

      </div>
    </Router>
    );
    } else {
      return (
        <div>
      <Topbar />
      <div className="container-fluid">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 content-loading">
                <article>
                  <h2 style={{textAlign:"center"}}>Ladataan...</h2>
                </article>
              </div>
                
            </div>
          </div>
        </div>
      
        <Footer/>

      </div>
      );
    }
    
  }
}

export default App


// WEBPACK FOOTER //
// ./src/app/components/App.js